module.exports = __webpack_public_path__ + "media/assets/rajen-bb5f7bad395e10c7e7c56f7aeb52788f.jpg";